module.exports = __webpack_public_path__ + "img/MM.f06bd610.svg";